import './index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import {SelectVenueProvider} from './contexts/SelectedVenueContext'
import {ToastProvider} from './contexts/ToastContext'
import {ThemeProvider} from './contexts/ThemeContext'
import {OfflineBanner} from './components/OfflineBanner/OfflineBanner'
import {removeDeprecatedCollectionFormLocalStorageKeys} from './utils/removeDeprecatedCollectionFormLocalStorageKeys'

removeDeprecatedCollectionFormLocalStorageKeys()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <OfflineBanner />
      <ToastProvider>
        <SelectVenueProvider>
          <App />
        </SelectVenueProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
